import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { UPDATE_TIMESHEET } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";

/*
 * Edit path. Note the element fields carry no `in_` prefix — that is the
 * contract this endpoint expects.
 */
export const updateTimesheet = async (cookiesData, dispatch, payload) => {
  if (!cookiesData) return { status: false, message: "Not authenticated" };

  try {
    const apiHeaders = generateHeader();
    const response = await POSTAPI(false, UPDATE_TIMESHEET, null, apiHeaders, payload, dispatch);
    const outParams = response?.data?.out_parameters ?? {};

    if (outParams.out_ret_code === API_CONSTANTS.SUCCESS_CODE) {
      return { status: true, message: response?.msg || "Pay request updated" };
    }
    return { status: false, message: outParams.out_error_msg || "Failed to update pay request" };
  } catch (error) {
    console.error("Error updating timesheet:", error);
    return { status: false, message: error?.message || "Unable to reach the server" };
  }
};
